/** @file A button-styled file picker: choosing files calls onFiles; the same file can be chosen again. */
import type { ChangeEvent } from 'react';
import type { PickedFile } from './importTypes';
import '../ui-kit/Button.css';
import './import.css';

/** Props of FilePicker; `label` is already translated. */
export interface FilePickerProps {
  label: string;
  accept: string;
  multiple: boolean;
  disabled?: boolean;
  onFiles: (files: PickedFile[]) => void;
}

/** A label around a visually hidden (still focusable) file input; the input is cleared after each choice. */
export function FilePicker({ label, accept, multiple, disabled = false, onFiles }: FilePickerProps) {
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const files = Array.from(e.currentTarget.files ?? []);
    e.currentTarget.value = '';
    if (files.length > 0) onFiles(files);
  };
  return (
    <label className="p2-button import-picker">
      {label}
      <input type="file" className="import-file" accept={accept} multiple={multiple} disabled={disabled} onChange={onChange} />
    </label>
  );
}
